import React from "react";
import { Box, Button, Typography } from "@mui/material";
import { Link as RouterLink } from "react-router-dom";
import MyContainer from "../../../MyContainer";
import ArticleCard from "../../../ui/ArticleCard";
import Reveal from "../../../ui/Reveal";
import SectionEyebrow from "../../../ui/SectionEyebrow";
import { useBlogTeaserSectionStyles } from "./BlogTeaserSection.styles";
import { useI18n } from "../../../../i8n/useI18n";
import { useCommerceData } from "../../../../hooks/useCommerceData";
import { commerceRepository } from "../../../../api";

const BlogTeaserSection = () => {
    const { classes } = useBlogTeaserSectionStyles();
    const { t } = useI18n();
    const { data } = useCommerceData(() => commerceRepository.getArticles({ first: 3 }), []);

    return (
        <Box className={classes.root}>
            <MyContainer>
                <Reveal>
                    <Box className={classes.header}>
                        <Box>
                            <SectionEyebrow label={t("home.blogTeaserSection.overline")} />
                            <Typography variant="h2" sx={{ mt: 2 }}>{t("home.blogTeaserSection.title")}</Typography>
                            <Typography variant="body1" className={classes.description}>
                                {t("home.blogTeaserSection.description")}
                            </Typography>
                        </Box>
                        <Button variant="outlined" component={RouterLink} to={t("links.blog")}>
                            {t("home.blogTeaserSection.cta")}
                        </Button>
                    </Box>
                </Reveal>

                <Box className={classes.grid}>
                    {data?.items.map((article, index) => (
                        <Reveal key={article.id} delay={index * 0.05}>
                            <ArticleCard article={article} />
                        </Reveal>
                    ))}
                </Box>
            </MyContainer>
        </Box>
    );
};

export default BlogTeaserSection;
